import React from 'react';
import { Modal, Button } from 'tea-component';
import Abnormal from '@home/components/Abnormal';
import YamlEditor from '@/pages/datalab/components/YamlEditor';
import { COMMON_COMPLETION } from '@/pages/datalab/components/YamlEditor/constant';

interface IDetailModalProps {
  visible: boolean;
  name?: string;
  yaml?: string;
  isLoading: boolean;
  isError: boolean;
  onClose: () => void;
  formatMessage: (descriptor: { id: string; }, values?: Record<string, any>) => string;
}

const DetailModal: React.FC<IDetailModalProps> = (props: IDetailModalProps) => {
  const { visible, name, yaml, isLoading, isError, onClose, formatMessage } = props;
  return (
    <Modal className={`dbl-model-management-detail-modal`} visible={visible} caption={name} onClose={onClose}>
      <Modal.Body>
        <Abnormal
          style={{ height: '100%' }}
          isLoading={isLoading}
          isError={isError}
          component={<YamlEditor value={yaml} readOnly={true} completions={COMMON_COMPLETION} />}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button type="primary" onClick={onClose}>
          {formatMessage({ id: 'dbl_common_close' })}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DetailModal;


